module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showNeueStriche = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Erstellen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showRechnungenGenerieren = true) && (_vm.fortschritt = 0) && (_vm.e1 = 1)
            }
          }
        }, on), [_c('v-icon', [_vm._v("send")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Rechnungen erstellen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showStatistik = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("insights")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Statistik")])])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.showStatistik) ? _c('v-dialog', {
    attrs: {
      "width": "70%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showStatistik),
      callback: function($$v) {
        _vm.showStatistik = $$v
      },
      expression: "showStatistik"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_c('div', [_vm._v("Statistik")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showStatistik = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(_vm._s(_vm.statistik.anzahlStriche))]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Striche")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(_vm._s(_vm.statistik.anzahlEKP))]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("EKP")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(_vm._s(_vm.statistik.anzahlPauschal))]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Pauschal")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(_vm._s(_vm.statistik.anzahlRechnungen))]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Rechnungen")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "text-center pt-1",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": 270,
      "size": 80,
      "width": 5,
      "value": (_vm.statistik.umsatzStriche / _vm.statistik.umsatzGesamt) * 100,
      "color": "primary"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")(_vm.statistik.umsatzStriche)) + "\n                  ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-1"
  }, [_vm._v("Umsatz "), _c('br'), _vm._v("\n                    Striche")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "text-center pt-1",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": 270,
      "size": 80,
      "width": 5,
      "value": (_vm.statistik.umsatzEKP / _vm.statistik.umsatzGesamt) * 100,
      "color": "primary"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")(_vm.statistik.umsatzEKP)) + "\n                  ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-1"
  }, [_vm._v("Umsatz "), _c('br'), _vm._v("\n                    EKP")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "text-center pt-1",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": 270,
      "size": 80,
      "width": 5,
      "value": (_vm.statistik.umsatzPauschal / _vm.statistik.umsatzGesamt) * 100,
      "color": "primary"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")(_vm.statistik.umsatzPauschal)) + "\n                  ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-1"
  }, [_vm._v("Umsatz"), _c('br'), _vm._v("Pauschal")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "text-center pt-1",
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": 270,
      "size": 80,
      "width": 5,
      "value": (_vm.statistik.umsatzGesamt / _vm.statistik.umsatzGesamt) * 100,
      "color": "primary"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")(_vm.statistik.umsatzGesamt)) + "\n                  ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-1"
  }, [_vm._v("Umsatz Gesamt")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "378px"
    }
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bbr")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Striche")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pauschal")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statistik.bestenliste), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.id, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.striche))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.ekp)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.pauschal)))])])
  }), 0)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showStatistik = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showNeueStriche) ? _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNeueStriche),
      callback: function($$v) {
        _vm.showNeueStriche = $$v
      },
      expression: "showNeueStriche"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-title', [_c('div', [_vm._v("Neue Striche erstellen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeueStriche = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('stricheNeu')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeueStriche = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showRechnungenGenerieren) ? _c('v-dialog', {
    attrs: {
      "width": "60%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showRechnungenGenerieren),
      callback: function($$v) {
        _vm.showRechnungenGenerieren = $$v
      },
      expression: "showRechnungenGenerieren"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("\n        Rechnungen erstellen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        (_vm.showRechnungenGenerieren = false) && (_vm.$vars.loading = false)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-stepper', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "flat": "",
      "outlined": ""
    },
    model: {
      value: (_vm.e1),
      callback: function($$v) {
        _vm.e1 = $$v
      },
      expression: "e1"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 1,
      "step": "1"
    }
  }, [_vm._v(" Datum auswählen ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 2,
      "step": "2"
    }
  }, [_vm._v(" Rechnungsdetails ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v(" Zusammenfassung ")])], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": "1"
    }
  }, [_c('v-card', {
    staticClass: "pa-1",
    attrs: {
      "height": "500px"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Alle offenen Striche berechnen"
    },
    model: {
      value: (_vm.rechnung_alle),
      callback: function($$v) {
        _vm.rechnung_alle = $$v
      },
      expression: "rechnung_alle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [(!_vm.rechnung_alle) ? _c('v-date-picker', {
    attrs: {
      "full-width": "",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "no-title": "",
      "locale": "de-de"
    },
    model: {
      value: (_vm.rechnung_von),
      callback: function($$v) {
        _vm.rechnung_von = $$v
      },
      expression: "rechnung_von"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [(!_vm.rechnung_alle) ? _c('v-date-picker', {
    attrs: {
      "full-width": "",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "no-title": "",
      "locale": "de-de"
    },
    model: {
      value: (_vm.rechnung_bis),
      callback: function($$v) {
        _vm.rechnung_bis = $$v
      },
      expression: "rechnung_bis"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": "2"
    }
  }, [_c('v-card', {
    staticClass: "pa-1",
    attrs: {
      "height": "500px"
    }
  }, [_c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "py-0 mt-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "Rechnungstitel"
    },
    model: {
      value: (_vm.rechnung_titel),
      callback: function($$v) {
        _vm.rechnung_titel = $$v
      },
      expression: "rechnung_titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0 mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "Rechnungsdatum"
    },
    model: {
      value: (_vm.rechnung_datum),
      callback: function($$v) {
        _vm.rechnung_datum = $$v
      },
      expression: "rechnung_datum"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0 mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "Zahlbar bis",
      "messages": "Standard: 10 Tage später"
    },
    model: {
      value: (_vm.rechnung_zahlbar_bis),
      callback: function($$v) {
        _vm.rechnung_zahlbar_bis = $$v
      },
      expression: "rechnung_zahlbar_bis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hint": "<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>",
      "label": "Rechnungstext"
    },
    model: {
      value: (_vm.rechnung_freitext),
      callback: function($$v) {
        _vm.rechnung_freitext = $$v
      },
      expression: "rechnung_freitext"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hint": "<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>",
      "label": "Rechnungstext bei SEPA-Rechnung"
    },
    model: {
      value: (_vm.rechnung_freitext_sepa),
      callback: function($$v) {
        _vm.rechnung_freitext_sepa = $$v
      },
      expression: "rechnung_freitext_sepa"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": "3"
    }
  }, [_c('v-card', {
    staticClass: "pa-1",
    attrs: {
      "height": "500px"
    }
  }, [_c('v-row', {
    staticClass: "ma-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-1 pb-0 subtitle-2"
  }, [_vm._v("Zahlbar bis")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center pt-0 pb-1"
  }, [_vm._v(_vm._s(_vm.$filters.date(_vm.rechnung_zahlbar_bis, "DD.MM.YYYY")))])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-1 pb-0 subtitle-2"
  }, [_vm._v("Rechnungen")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center pt-0 pb-1"
  }, [_vm._v(_vm._s(_vm.rechnung_anzahl))])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-1 pb-0 subtitle-2"
  }, [_vm._v("Betrag")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center pt-0 pb-1"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.rechnung_summe)))])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-1 pb-0 subtitle-2"
  }, [_vm._v("Davon per SEPA")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center pt-0 pb-1"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.rechnung_summe_sepa)))])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-1 pb-0 subtitle-2"
  }, [_vm._v("Striche")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center pt-0 pb-1"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.rechnung_summe_striche)))])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-1 pb-0 subtitle-2"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center pt-0 pb-1"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.rechnung_summe_ekp)))])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-1 pb-0 subtitle-2"
  }, [_vm._v("Pauschal")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center pt-0 pb-1"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.rechnung_summe_pauschal)))])], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-1"
  }), _vm._v(" "), (_vm.rechnungen.length > 0) ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.index < 1
    },
    on: {
      "click": function($event) {
        _vm.index -= 1
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center subtitle-2"
  }, [_vm._v("Rechnung " + _vm._s(_vm.index + 1) + " von " + _vm._s(_vm.rechnungen.length))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.index > _vm.rechnungen.length - 2
    },
    on: {
      "click": function($event) {
        _vm.index += 1
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center subtitle-2"
  }, [_vm._v("\n                        " + _vm._s(_vm.$filters.user(_vm.rechnungen[_vm.index].bbrID, _vm.bbrbbr)) + "\n                      ")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "150"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    attrs: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Was")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Betrag")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rechnungen[_vm.index].positionen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.was))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.betrag)))])])
  }), 0)])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": "4"
    }
  }, [_c('v-card', {
    staticClass: "pa-1",
    attrs: {
      "height": "500px"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(" Rechnungen werden erstellt ")]), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "color": _vm.fortschritt === 100 ? 'green' : 'blue',
      "value": _vm.fortschritt,
      "height": "32",
      "rounded": ""
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.fortschritt.toFixed(0)) + " %\n                ")]), _vm._v(" "), (_vm.fortschritt < 100) ? _c('v-progress-linear', {
    staticClass: "mt-n1",
    attrs: {
      "color": "blue",
      "height": "4",
      "indeterminate": "",
      "rounded": ""
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(_vm.e1 < 4) ? _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        (_vm.showRechnungenGenerieren = false) && (_vm.loading = false)
      }
    }
  }, [_vm._v("Abbrechen")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.e1 === 1) ? _c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_vm._v("Weiter")])], 1) : _vm._e(), _vm._v(" "), (_vm.e1 === 2) ? _c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.e1 = 1
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.rechnungVorbereiten
    }
  }, [_vm._v("Weiter")])], 1) : _vm._e(), _vm._v(" "), (_vm.e1 === 3) ? _c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.rechnungErstellen
    }
  }, [_vm._v("Erstellen")])], 1) : _vm._e(), _vm._v(" "), (_vm.e1 === 4) ? _c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.fortschritt < 100
    },
    on: {
      "click": function($event) {
        _vm.showRechnungenGenerieren = false
      }
    }
  }, [_vm._v("Schließen")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "dense": "",
      "height": _vm.sideHeight,
      "headers": _vm.headers,
      "items": _vm.striche,
      "search": _vm.search,
      "fixed-header": "",
      "items-per-page": 50,
      "footer-props": {
        'items-per-page-options': [50, 250, -1],
        'items-per-page-text': 'Striche pro Seite',
      },
      "no-data-text": "Keine Striche vorhanden"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          staticClass: "hidden-sm-and-up"
        }, [_c('th', [_vm._v("Bundesbruder")]), _vm._v(" "), _c('th', [_vm._v("Datum")]), _vm._v(" "), _c('th', [_vm._v("Betrag")])])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbrID, _vm.bbrbbr)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(item.date, "DD.MM.YYYY")))]), _vm._v(" "), _c('td', {
          staticClass: "hidden-xs-only"
        }, [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")((item.preis * item.anzahl))))]), _vm._v(" "), _c('td', {
          staticClass: "hidden-xs-only"
        }, [_vm._v(_vm._s(item.grund))]), _vm._v(" "), _c('td', {
          staticClass: "pl-0 pr-0 hidden-xs-only",
          attrs: {
            "width": "20px"
          }
        }, [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteStrich(item.id)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])]
      }
    }, {
      key: "footer",
      fn: function() {
        return [_c('v-divider'), _vm._v(" "), _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-spacer'), _vm._v(" "), _c('div', {
          staticClass: "subtitle-2 mt-2 mb-2 mr-2"
        }, [_vm._v("Anzahl Striche: " + _vm._s(_vm.anzahl) + " - Summe: " + _vm._s(_vm._f("money")(_vm.summe)))])], 1)]
      },
      proxy: true
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00ccb0de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/bierwartStriche.vue
// module id = 730
// module chunks = 15